import React from 'react'
import Constants from 'EurestoFonction/Constants'

import Formulaire from 'Components/Formulaire'
import Template from './form'

const columns = [{
  header: 'Id',
  id: 'id',
  show: false,
}, {
  id: 'libelle',
  headerClassName: 'EurestoPrimary EurestoText--text',
  header: <strong style={{
    display: 'block',
    width: '100%'
  }}>{EurestoI18n.t('commun:Groupe Utilisateur')}</strong>,
  type: 'string',
}, {
  id: 'email',
  headerClassName: 'EurestoPrimary EurestoText--text',
  header: <strong style={{
    display: 'block',
    width: '100%'
  }}>{EurestoI18n.t('commun:Email')}</strong>,
  type: 'string',
}]

export default React.memo(props => <Formulaire defaultObject={{
  abrege: undefined, libelle: undefined, actif: 1
}} title={EurestoI18n.t('commun:Groupe Utilisateur')} columnSearch={'id'} form={<Template/>} module={Constants.module.CONFIGURATION} requete={Constants.donnee.groupe_utilisateur} columns={columns}/>)


// WEBPACK FOOTER //
// ./app/App/Module/Configuration/Component/Etablissement/Regroupement/index.js